"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _localization = require("@lt/localization");
var _Button = _interopRequireDefault(require("../../Button"));
var HotelCardExploreButton = function HotelCardExploreButton(_ref) {
  var href = _ref.href,
    isCardHovered = _ref.isCardHovered,
    isSmallCard = _ref.isSmallCard,
    dataLayer = _ref.dataLayer,
    openInCurrentTab = _ref.openInCurrentTab,
    isHotelOnly = _ref.isHotelOnly;
  var _useTranslation = (0, _localization.useTranslation)(),
    t = _useTranslation.t;
  return /*#__PURE__*/_react["default"].createElement(Link, {
    href: href,
    target: openInCurrentTab ? '_self' : '_blank',
    rel: "noopener",
    "data-at-search-hotel-card": href,
    onClick: dataLayer === null || dataLayer === void 0 ? void 0 : dataLayer.hotelClicked
  }, /*#__PURE__*/_react["default"].createElement(StyledButton, {
    isCardHovered: isCardHovered,
    isSmallCard: isSmallCard
  }, t('hotelcard.card.button', {
    context: isHotelOnly ? 'hotel' : 'package'
  })));
};
var Link = _styledComponents["default"].a.withConfig({
  displayName: "HotelCardExploreButton__Link",
  componentId: "sc-154nrzo-0"
})(["text-decoration:none;margin-top:auto;margin-left:auto;"]);
var StyledButton = (0, _styledComponents["default"])(_Button["default"]).attrs(function (_ref2) {
  var isCardHovered = _ref2.isCardHovered;
  return {
    primary: isCardHovered
  };
}).withConfig({
  displayName: "HotelCardExploreButton__StyledButton",
  componentId: "sc-154nrzo-1"
})(["", " color:", ";max-width:", " ", " flex-shrink:0;height:46px;width:130px;white-space:pre-line;font-size:14px;line-height:16px;font-weight:500;border-radius:2px;padding:4px 8px 6px 8px;"], function (_ref3) {
  var isCardHovered = _ref3.isCardHovered;
  return !isCardHovered && "\n      border: none;\n      background-color: #fff;\n      box-shadow: inset 0 0 0 1px #b3b3b3, 0 1px 0 0 #e0e0e0;\n    ";
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.blackBase;
}, function (_ref5) {
  var isSmallCard = _ref5.isSmallCard;
  return "".concat(isSmallCard ? 116 : 130, "px;");
}, function (_ref6) {
  var isSmallCard = _ref6.isSmallCard;
  return isSmallCard && "padding: 4px 8px;";
});
var _default = exports["default"] = HotelCardExploreButton;